import { take, takeEvery, put } from 'redux-saga/effects'
import moment from 'moment'

import * as grs from '../grs'
import getRandomness from '../shared/random-generator'
import { getTimeSpan } from '../shared/time-utilites'

import * as constants from './constants'
import * as actions from './actions'

const locationRatesPredicate = (requestId, action) =>
    [grs.constants.RECEIVED_LOCATION_RATES, grs.constants.FAILED_TO_FETCH_RATES].indexOf(action.type) !== -1 &&
    action.requestId === requestId

export function* getRates({ grsId }) {
    yield put(actions.setRates(null))
    const requestId = getRandomness()
    const { start: beginTime, end: endTime } = getTimeSpan(moment().add(1, 'weeks'), 30, 60)
    yield put(
        grs.actions.fetchRates(
            [
                {
                    grsId,
                    beginTime,
                    endTime,
                },
            ],
            requestId
        )
    )

    const { result } = yield take(locationRatesPredicate.bind(null, requestId))

    if (result) {
        yield put(actions.setRates(result))
    }
}

export default function* watchGetRates() {
    yield takeEvery(constants.GET_RATES, getRates)
}

export { watchGetRates as rootSaga }
